import { useAuth } from '@/shared/auth';
import type { Api } from './endpoints';

/**
 * Bequemer Zugriff auf die typisierten API-Endpoints in Components.
 *
 * Verwendung:
 *   const api = useApi();
 *   const { data } = useQuery({ queryKey: ['properties'], queryFn: () => api.properties.list({}) });
 */
export function useApi(): Api {
  return useAuth().api;
}
